import moment from 'moment'

const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

export const fmN = (n) => n === null || n === undefined ? '—' : Math.round(n).toLocaleString('vi-VN')

export const fmP = (n) => n === null || n === undefined ? '—' : `${(n * 100).toFixed(2)}%`

export const fmDate = (dateString) => dateString ? dateString.split('-').reverse().join('/') : '—'

export const monthLabel = (month) => MONTH_NAMES[Number(month.slice(5, 7)) - 1]

export const dayLabel = (dateString) => String(Number(dateString.slice(8, 10)))

export const fmAsOf = (asOf) => asOf && asOf.finished_at ? moment(asOf.finished_at).format('HH:mm DD/MM/YYYY') : null

// Ngày D chốt sổ lúc 05:00 ngày D+3 (BR-06-6)
export const closingTime = (dateString) => `05:00 ${moment(dateString, 'YYYY-MM-DD').add(3, 'days').format('DD/MM')}`

export const today = () => moment().format('YYYY-MM-DD')

export const addDays = (dateString, days) => moment(dateString, 'YYYY-MM-DD').add(days, 'days').format('YYYY-MM-DD')

export const countDays = (from, to) => moment(to, 'YYYY-MM-DD').diff(moment(from, 'YYYY-MM-DD'), 'days') + 1

// Cùng định dạng với thanh lọc: "01/09/2026 – 30/09/2026 (30 ngày)"
export const fmRange = (range) => range && range.from && range.to
    ? `${fmDate(range.from)} – ${fmDate(range.to)} (${countDays(range.from, range.to)} ngày)`
    : ''

export const startOfMonth = (dateString) => `${dateString.slice(0, 7)}-01`

// Lỗi QC không ghi chi tiết vẫn có cột Pareto riêng, đặt tên theo nhóm lỗi
export const detailLabel = (entry) => entry.error_detail || `${entry.label} (không ghi chi tiết)`
